import DashboardContent from 'components/lab/atoms/DashboardContent'
import { BillingEraReportsListing } from 'components/lab/billingEraReports/BillingEraReportsListing'
import routes from 'components/lab/constants/routes'
import React from 'react'

export const BillingEraReportsListingPage = () => {
  return (
    <div>
      <DashboardContent
        title={'Billing ERA Files'}
        icon="fa fa-hdd"
        content={
          <div>
            <div className="card card-primary mt-1 p-2">
              <BillingEraReportsListing />
            </div>
          </div>
        }
        breadcrumb={[
          {
            label: 'Billing Charges',
            to: `${routes.index}`,
          },
        ]}
      />
    </div>
  )
}
